import React from 'react';

import { authAction } from '../../../../_actions/authAction';

const StartTimer = (dispatch, detectMove) => {
    dispatch(authAction(window.localStorage.getItem('cookie')));
    document.addEventListener('mousemove', detectMove);
};

export default StartTimer;